"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var SUBDOMAIN_URL = '/reports/v1/domains/sources';
var BASIC_URL = '/content/api/v4/domains?casing=snake&offset=0&limit=9999';

var DomainsAPI =
/*#__PURE__*/
function () {
  function DomainsAPI() {
    (0, _classCallCheck2.default)(this, DomainsAPI);
  }

  (0, _createClass2.default)(DomainsAPI, null, [{
    key: "get",
    value: function get(gates) {
      var url = gates.includes('Analytics:AllSubdomainProcessing') ? SUBDOMAIN_URL : BASIC_URL;
      return _apiClient.default.get(url).then(function (response) {
        if (response.objects) {
          return response.objects.filter(function (domain) {
            return domain.is_any_primary && (!gates.includes('cos_only') || !domain.isLegacy);
          });
        }

        return response.filter(function (domain) {
          return domain.showInSources;
        });
      });
    }
  }]);
  return DomainsAPI;
}();

exports.default = DomainsAPI;
module.exports = exports.default;